import React from 'react';
const services = [{
  title: 'Residential Carpet Cleaning',
  image: 'https://cdn.magicpatterns.com/uploads/ekcJfZRBxbM959rdvAThjj/65c57d_849a3781b60e4e6c99cb37d599e87ab3~mv2_d_5760_3744_s_4_2.png',
  description: 'Deep steam cleaning for homes of all sizes. We remove stains, odors, and allergens using truck-mounted equipment.',
  cta: 'Learn More →'
}, {
  title: 'Commercial Carpet Cleaning',
  image: 'https://cdn.magicpatterns.com/uploads/8YVXhiB5YNjVP4hJFnWipA/uneebo-office-design-6182SnH84II-unsplash.jpg',
  description: 'From 1,000 to 100,000+ sq ft — our commercial crew has the equipment and experience to handle any facility.',
  cta: 'Get a Quote →'
}, {
  title: 'Tile & Grout Cleaning',
  image: 'https://cdn.magicpatterns.com/uploads/rUGqMYCKB7SWC5q3uyXkNy/naomi-hebert-MP0bgaS_d1c-unsplash.jpg',
  description: 'Restore your ceramic and porcelain tile to its original beauty. Professional-grade cleaning that goes beyond mopping.',
  cta: 'Learn More →'
}];
export function ServicesSection() {
  return <section id="services" className="py-16 md:py-24 bg-white" data-id="element-153">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-154">
        <div className="text-center mb-12 md:mb-16" data-id="element-155">
          <h2 className="font-heading text-3xl md:text-4xl font-bold italic text-navy uppercase mb-4" data-id="element-156">
            Our Services
          </h2>
          <p className="text-lg text-silver max-w-2xl mx-auto" data-id="element-157">
            From carpet to tile and grout — we bring your floors back to life.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-158">
          {services.map((service, index) => <div key={index} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col border border-light-gray" data-id="element-159">
              <div className="h-48 md:h-56 overflow-hidden" data-id="element-160">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover" data-id="element-161" />
              </div>
              <div className="p-6 md:p-8 flex flex-col flex-grow" data-id="element-162">
                <h3 className="font-heading text-xl font-bold italic text-navy mb-3" data-id="element-163">
                  {service.title}
                </h3>
                <p className="text-silver mb-6 flex-grow leading-relaxed" data-id="element-164">
                  {service.description}
                </p>
                <a href="#contact" className="text-red hover:text-red-hover font-bold inline-flex items-center transition-colors min-h-[44px]" data-id="element-165">
                  {service.cta}
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}